/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc.
( * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import config from "./config";

const piSession = window.piSession;

function getLoginSuccessRedirectURL() {
    return window.location.href;
}

export function impersonateUser(username) {
    piSession.autoimpersonate(username, config.instructorPortal.baseUrl);
}

function handleSessionChange(onChange) {
    piSession.getToken((status, token) => {
        switch (status) {
            case piSession.Success: {
                onChange(token);
                break;
            }
            case piSession.NoToken: {
                login();
                break;
            }
            default: {
                break;
            }
        }
    });
}


function login() {
    piSession.login(getLoginSuccessRedirectURL());
}

export function logout() {
    piSession.logout();
}

export default function init(callback) {
    piSession.initialize(config.pi.clientId, {
        checkSessionMilliseconds: 3000,
        sessionIdleTimeoutSeconds: 3600,
        autoRefresh: true,
        loginSuccessUrl : getLoginSuccessRedirectURL(),
        requireLogin : true
    });

    piSession.on(piSession.SessionStateKnownEvent, () =>
        handleSessionChange(callback)
    );
    piSession.on(piSession.RefreshEvent, () => handleSessionChange(callback));
    piSession.on(piSession.LogoutEvent, login);
}



// WEBPACK FOOTER //
// ./src/session.initialize.js